import React from 'react';
import styled from 'styled-components';
import { motion } from 'motion/react';
import { ContextualAttachment } from '@/features/ai-agents/shared/models';

export interface ChatContextualTileProps {
  attachment: ContextualAttachment;
  canDelete?: boolean;
  onDelete?: (() => void) | ((id: string) => void);
}

export function ChatContextualTile({
  attachment,
  canDelete,
  onDelete,
}: ChatContextualTileProps) {
  const onDeleteClicked = (ev: React.MouseEvent) => {
    if (canDelete && onDelete) {
      ev.stopPropagation();
      if (onDelete.length === 0) {
        (onDelete as () => void)();
      } else {
        (onDelete as (id: string) => void)(attachment.id);
      }
    }
  };

  return (
    <Wrapper layout>
      <Caption>{attachment.caption}</Caption>
      {canDelete && <DeleteButton onClick={onDeleteClicked}>✕</DeleteButton>}
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: 0.8rem;
  padding: 0.6rem 1.2rem;
  border-radius: 0.4rem;
  box-shadow: 0 1px 7px 0 rgba(0, 0, 0, 0.06);
  border: solid 0.5px #ff8fd0;
  background-color: #ffe3f4;
  color: #e02073;
  font-size: 1.2rem;
  font-weight: 500;
  position: relative;
  white-space: nowrap;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  font-family: Inter, sans-serif;

  user-select: none;
  && * {
    user-select: none;
  }

  &&::selection {
    background-color: #ff4fa3;
    color: #ffffff;
  }
`;

export const AddContextButton = styled(Wrapper)`
  && {
    cursor: pointer;
    transition: background-color 0.2s;
    font-size: 1.4rem;
    height: 3.1rem;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #ffd1e6;
    }

    &:active {
      background-color: #ffb3d1;
    }
  }
`;

const Caption = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 500;
`;

const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 50%;
  width: 1.8rem;
  height: 1.8rem;
  cursor: pointer;
  color: rgba(217, 70, 166, 0.46);
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0;
  flex-shrink: 0;
  transition: background 0.2s;

  &:hover {
    background: rgba(217, 70, 166, 0.1);
  }
`;
